import { Button, Popover } from '@heroui/react'
import { CircleQuestionMarkIcon } from 'lucide-react'

export interface InfoPopoverProps {
  info?: string
}

// Small info affordance rendered next to a question that carries a disclaimer.
// Renders nothing when there is no `info`, so fields without one are untouched.
export const InfoPopover = ({ info }: InfoPopoverProps) => {
  if (!info) return null

  return (
    <Popover>
      <Button isIconOnly size="md" variant="ghost" aria-label="More info">
        <CircleQuestionMarkIcon className="size-6" strokeWidth={1} />
      </Button>
      <Popover.Content className="max-w-64" placement="top right">
        <Popover.Dialog>
          <Popover.Arrow />
          <p className="text-sm">{info}</p>
        </Popover.Dialog>
      </Popover.Content>
    </Popover>
  )
}
